export default __webpack_public_path__ + "937e6cd9e83e3bf2abcfef5142e2fa47.png";